import React, { memo, useCallback } from "react";
import PropTypes from "prop-types";

import {
	BettoGameGridTransition,
	CARD_VARIANT,
} from "@pages/casino/containers/BettoGameGridTransition";
import {
	buildAllGamesBrowseRoute,
	clearBettoCasinoBrowseFilters,
	isBettoFavoritesActive,
} from "@pages/casino/utils/bettoProviderFilter";

import { BettoFavoriteGameCard } from "./BettoFavoriteGameCard.jsx";
import { BettoFavoritesEmpty } from "./BettoFavoritesEmpty.jsx";
import useBettoFavoritesController from "./useBettoFavoritesController.js";

export const BettoFavoritesBrowse = memo(({ translate, history, location }) => {
	const isActive = isBettoFavoritesActive(location);

	const {
		state: { favoriteGames, isFavoritesLoading },
		handlers: { handleRemoveFavorite },
	} = useBettoFavoritesController({ loadFavorites: isActive });

	const handleExploreAllGames = useCallback(() => {
		clearBettoCasinoBrowseFilters();
		history.push(buildAllGamesBrowseRoute("casino"));
	}, [history]);

	if (!isActive) return null;

	return (
		<BettoGameGridTransition
			isLoading={isFavoritesLoading}
			games={favoriteGames}
			transitionKey="betto-favorites"
			cardVariant={CARD_VARIANT.GRID}
			disableAnimation
			renderGame={(game, index) => (
				<BettoFavoriteGameCard
					game={game}
					imageIndex={index}
					onRemoveFavorite={handleRemoveFavorite}
				/>
			)}
			emptyState={
				<BettoFavoritesEmpty
					translate={translate}
					onExploreAllGames={handleExploreAllGames}
				/>
			}
		/>
	);
});

BettoFavoritesBrowse.displayName = "BettoFavoritesBrowse";

BettoFavoritesBrowse.propTypes = {
	translate: PropTypes.func.isRequired,
	history: PropTypes.object.isRequired,
	location: PropTypes.object.isRequired,
};

export default BettoFavoritesBrowse;
